import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  view: {
    height: 40,
    width: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
